'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _ApiClient = require('api/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _IBonusProxy = require('api/IBonusProxy');

var _IBonusProxy2 = _interopRequireDefault(_IBonusProxy);

var _helpers = require('helpers');

var _error = require('redux/actions/error');

var _reduxAsyncConnect = require('redux-async-connect');

var _payment = require('redux/actions/payment');

var _constants = require('./constants');

var _personal = require('redux/actions/personal');

var _utils = require('./utils');

var orderUtils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentOrder: {
        displayName: 'PaymentOrder'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Order/PaymentOrder.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PaymentOrder = _wrapComponent('PaymentOrder')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref, helpers) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState,
            params = _ref.params,
            query = _ref.location.query;

        var promises = [];
        var pipoId = getState().setting.pipoOnlineShopId;

        if (params && params.order_id > 0) {
            var resolveWait = void 0;
            var waitOrderPromise = new _promise2.default(function (resolve) {
                return resolveWait = resolve;
            });

            promises.push(dispatch((0, _personal.getPersonalOrderDetail)(params.order_id)).then(function (result) {
                resolveWait(result);
                return result;
            }));

            promises.push(waitOrderPromise.then(function (result) {
                if (query && query.hasOwnProperty('pi_type')) {
                    var type = query.pi_type;

                    var name = query.pi_name || '';
                    var value = query.pi_value || '';

                    return dispatch((0, _payment.loadProcessInput)(result.payment_in_id, type, name, value));
                }

                return _promise2.default.resolve(null);
            }));
        }

        promises.push(dispatch((0, _payment.getPayment)()));
        promises.push(dispatch((0, _payment.getPaymentsParamsFromPIPObyId)(pipoId)));

        return _promise2.default.all(promises);
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        payments: orderUtils.mergePaymentParameters(state.payment.list, state.payment.pipoList),
        payment_in_id: state.personal_order_detail.order.payment_in_id,
        channelId: state.setting.channelId,
        profileId: state.setting.profileId,
        buyInCreditActive: state.setting.buyInCreditActive,
        buyInCredit: state.setting.buyInCredit,
        processInput: state.payment.processInput,
        showCustomPayment: state.payment.isCustomPayment,
        orderId: state.personal_order_detail.order.id,
        products: state.personal_order_detail.order.products,
        orderDetail: state.personal_order_detail.order,
        state: state,
        lang: state.lang,
        currency: state.currency
    };
}, { resetCustomPayment: _payment.resetCustomPayment, resetProcessInput: _payment.resetProcessInput }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PaymentOrder, _Component);

    function PaymentOrder(props) {
        (0, _classCallCheck3.default)(this, PaymentOrder);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentOrder.__proto__ || (0, _getPrototypeOf2.default)(PaymentOrder)).call(this, props));

        _this.setTimeoutId = null;
        _this.orderId = 0;
        _this.showProcessInput = false;

        _this.clearTimeout = function () {
            if (_this.setTimeoutId) {
                clearTimeout(_this.setTimeoutId);
                _this.setTimeoutId = null;
            }
        };

        _this.handleSuccessStatusOrder = function (result) {
            if (result.paymentStatus) {
                var statusPay = parseInt(result.paymentStatus.id, 10) || 0;
                if (statusPay === _helpers.OrderHelper.PaymentStatusConstants.PAYMENT_STATUS_PAY || statusPay === _helpers.OrderHelper.PaymentStatusConstants.PAYMENT_STATUS_MONEY_TRANSFER) {
                    _this.setState({ complite: true });
                    _this.clearTimeout();

                    return;
                }
            }

            _this.setTimeoutId = setTimeout(_this.intervalStatusOrder, 3000);
        };

        _this.intervalStatusOrder = function () {
            if (_this.orderId) {
                var ibonus = new _IBonusProxy2.default(new _ApiClient2.default());
                ibonus.channelId = _this.props.channelId;
                ibonus.profileId = _this.props.profileId;
                ibonus.getOrderById(_this.orderId).then(_this.handleSuccessStatusOrder, function (err) {
                    (0, _error.error)(err.message); // todo: перепроверить
                    _this.clearTimeout();
                });
            }
        };

        if (props.params && props.params.order_id) {
            _this.orderId = parseInt(props.params.order_id, 10) || 0;
        }

        _this.state = {
            complite: false,
            failError: ''
        };
        if (props.orderDetail.sum > 0) {
            _this.showProcessInput = (0, _keys2.default)(props.processInput).length > 0;
        }
        return _this;
    }

    (0, _createClass3.default)(PaymentOrder, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error')) {
                this.setState({ complite: false, failError: this.props.location.query.error });
            } else if (this.props.location.query.hasOwnProperty('fail') && this.props.location.query.hasOwnProperty('error_message')) {
                this.setState({ complite: false, failError: this.props.location.query.error_message });
            } else if (this.props.location.query.hasOwnProperty('fail')) {
                var errorText = this.props.lang['store.payment_order.error_while_paying'];
                this.setState({ complite: false, failError: errorText });
            } else if (this.props.showCustomPayment || this.props.location.query.hasOwnProperty('success')) {
                this.setState({ complite: true });
            } else if (this.orderId > 0 && !this.showProcessInput) {
                this.setTimeoutId = setTimeout(this.intervalStatusOrder, 3000);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.showCustomPayment == false && nextProps.showCustomPayment == true) {
                this.setState({ complite: true });
            }

            if (this.orderId && nextProps.complite === true && !this.showProcessInput) {
                this.clearTimeout();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (!this.showProcessInput) {
                this.clearTimeout();
            }
            this.props.resetCustomPayment();
            if (!this.props.location.query.pi_type) {
                this.props.resetProcessInput();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var result = 'dark-green';
            var View = _helpers.ThemeHelper.getViewForContainer('PaymentOrder', null, { folderName: 'Order' });
            var _props = this.props,
                payments = _props.payments,
                payment_in_id = _props.payment_in_id,
                processInput = _props.processInput,
                orderId = _props.orderId,
                products = _props.products,
                orderDetail = _props.orderDetail,
                lang = _props.lang,
                currency = _props.currency;


            if (__CLIENT__) {
                var color = document.body.classList[0];

                switch (color) {
                    case _constants.GREEN:
                        result = 'cube';
                        break;
                    case _constants.BLUE:
                        result = 'blue';
                        break;
                    case _constants.ORANGE:
                        result = 'orange';
                        break;
                    case _constants.RED:
                        result = 'red';
                        break;
                    case _constants.NAVY:
                        result = 'navy';
                        break;
                    case _constants.DARK_THEME:
                        result = 'dark';
                        break;
                }
            }

            return _react3.default.createElement(View, {
                buyInCreditActive: this.props.buyInCreditActive,
                buyInCredit: this.props.buyInCredit,
                isCompleted: this.state.complite,
                failError: this.state.failError,
                color: result,
                payments: payments,
                payment_in_id: payment_in_id,
                processInput: processInput,
                showProcessInput: this.showProcessInput,
                orderId: orderId,
                products: products,
                orderDetail: orderDetail,
                lang: lang,
                currency: currency
            });
        }
    }]);
    return PaymentOrder;
}(_react2.Component), _class2.propTypes = {
    payments: _react2.PropTypes.array.isRequired,
    payment_in_id: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
    processInput: _react2.PropTypes.object,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp)) || _class) || _class));

exports.default = PaymentOrder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/PaymentOrder.jsx
// module id = 1821
// module chunks = 0